import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Stack, Select, MenuItem, DialogActions, DialogContent, DialogTitle, Dialog } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import CustomTextField from '../../../components/forms/theme-elements/CustomTextField';
import CustomFormLabel from '../../../components/forms/theme-elements/CustomFormLabel';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useAuth } from '../../../guards/jwt/JwtContext';
import toast from 'react-hot-toast';
import PhoneInputCustom from '../../../components/PhoneInputCustom';
import axios from 'axios';
import { Email } from '@mui/icons-material';

const AuthRegister = ({ title, subtitle, subtext }) => {
  const { signup } = useAuth();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    country: '',
    phone: '',
    address: '',
  });
  const navigate = useNavigate();
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/v2/countries?all=1`);
        setCountries(response.data.data || []);
      } catch (error) {
        console.error('Error fetching countries:', error);
        toast.error('Failed to load countries');
      }
    };
    fetchCountries();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const [countries, setCountries] = useState([]);

  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phone: value });
  };
  const [openDialog, setOpenDialog] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signup(formData);
      // toast.success('Registration successful!');
      setOpenDialog(true); // Show dialog instead of navigating

    } catch (error) {
      toast.error(
        Object.values(error?.response?.data?.data || {})[0] || 
        error?.response?.data?.message || 
        'Failed to create booking'
      );    
      console.error('Registration Error:', error);
    }
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    navigate('/auth/login/');
  };
  
  return (
    <>
      {title ? (
        <Typography fontWeight="700" variant="h3" mb={1}>
          {title}
        </Typography>
      ) : null}

      {subtext}

      <Box component="form" onSubmit={handleSubmit}>
        <Stack mb={3}>
          <CustomFormLabel htmlFor="name">Name</CustomFormLabel>
          <CustomTextField id="name" name="name" variant="outlined" fullWidth onChange={handleChange} />
          <CustomFormLabel htmlFor="email">Email Address</CustomFormLabel>
          <CustomTextField id="email" name="email" variant="outlined" fullWidth onChange={handleChange} />
          <CustomFormLabel htmlFor="password" type="password">Password</CustomFormLabel>
          <CustomTextField id="password" name="password" type="password" variant="outlined" fullWidth onChange={handleChange} />
          <CustomFormLabel htmlFor="country">Country</CustomFormLabel>
          <Select
            id="country"
            name="country"
            value={formData.country}
            onChange={handleChange}
            fullWidth
            size="small"
          >
            <MenuItem value="">Select a country</MenuItem>
            {countries.map((country) => (
              <MenuItem key={country.cname} value={country.cname}>
                {country.cname}
              </MenuItem>
            ))}
          </Select>
          <CustomFormLabel htmlFor="phone">Phone</CustomFormLabel>
          <PhoneInputCustom
                      value={formData.phone}
                      onChange={handlePhoneChange}
                      size='small'
                      style={{
                        width: '100%'
                      }}
                />
              
          <CustomFormLabel htmlFor="address">Address</CustomFormLabel>
          <CustomTextField id="address" name="address" variant="outlined" fullWidth onChange={handleChange} />
        </Stack>
        <Button color="primary" variant="contained" size="large" fullWidth type="submit">
          Sign Up
        </Button>
      </Box>
      {subtitle}
      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>Registration Successful!</DialogTitle>
      <DialogContent sx={{ textAlign: 'center', py: 3 }}>
        <Email sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          Please Check Your Email
        </Typography>
        <Typography variant="body1" color="text.secondary">
          We've sent a confirmation link to your email address. Please check your inbox and confirm your email to activate your account.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button 
          onClick={handleCloseDialog}
          variant="contained" 
          fullWidth
        >
          Go to Login
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default AuthRegister;